<script lang="ts">
    import { Image, Input, InputGroup, InputGroupText } from "sveltestrap";
    let imgPath:string = "/assets/images"
</script>
  <div class="comments-box">
    <div class="media">
        <Image fluid class="img-50 m-r-20 rounded-circle" alt="" src="{imgPath}/user/1.jpg" />
        <div class="media-body">
            <InputGroup class="text-box">
                <Input class="input-txt-bx" type="text" name="message-to-send" placeholder="Post Your commnets" />
                <InputGroupText>
                    <Image src="{imgPath}/smiley.png" alt="" />
                </InputGroupText>
            </InputGroup>
        </div>
    </div>
</div>